module.exports = __webpack_public_path__ + "img/banner2_3_jp.f697ab88.png";